import React, { useReducer } from "react";
import { filter } from "../reducers/filter";
import { setFilter } from "../actions/filter";
import { FilterState } from "../types";

const defaultContextValue = {
  filterValue: "" as FilterState,
  setFilterValue: (newFilterValue: FilterState) => {},
};
const initialState: FilterState = "";

export const FilterContext = React.createContext(defaultContextValue);

export const FilterProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(filter, initialState);

  const value = {
    filterValue: state,
    setFilterValue: (newFilterValue: FilterState) => {
      dispatch(setFilter(newFilterValue));
    },
  };

  return (
    <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
  );
};
